
import Communication from '../Communication/Communication'; //TODO make aliases

class SensorDataProvider {
  tempFilter(measure) {
    return measure.value !== null && measure.value !== -273;
  }

  rhFilter(measure) {
    return measure.value !== null && measure.value !== -1;
  }

  ppmFilter(measure) {
    return measure.value !== null && measure.value >= 400;
  }

  parseData(data, property, filter) {
    return data.map(measure => ({
      value: measure[property],
      time: measure.time / 1000,
    })).filter(filter);
  }

  async getData({startDate, endDate, sensorId}) {
    const response = await Communication.get({
      path: 'getSensorData',
      queryParams: {
        startDate,
        endDate,
        sensorId
      }
    });

    return {
      temp: this.parseData(response, 'temp', this.tempFilter),
      ppm: this.parseData(response, 'ppm', this.ppmFilter),
      rh: this.parseData(response, 'rh', this.rhFilter)
    }
  }
}

export default new SensorDataProvider();